<template>
  <div>
    <b-jumbotron>
      <b-row>
        <b-col cols="12" md="6" class="mission">
          <h1>Community Connectivity Map</h1>
          <h2>CoCoMap</h2>
          <div>
            <p>
              Focused on data gathering and analysis of community-driven networks around the world.
              We know there’s a lot of work to do in terms of social justice and policy development.
              Now more than ever data is at the center of every request, proposal or petition to governments
              and stakeholders in the form of evidence-based arguments.
            </p>
            <b-button variant="primary">
              <router-link to="/map" class="link">Check the map</router-link>
            </b-button>
          </div>
        </b-col>

        <b-col cols="12" md="6" class="blob">
          <b-img
            src="https://images.unsplash.com/photo-1511068797325-6083f0f872b1?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80"
            fluid-grow
            alt="Responsive image"
          ></b-img>
        </b-col>
      </b-row>
    </b-jumbotron>
  </div>
</template>

<script>
export default {
  name: "Header"
};
</script>

<style scoped>
.jumbotron {
  height: 70vh;
}

.blob {
  overflow: hidden;
}

img {
  width: 100%;
}

.mission {
  align-self: flex-end;
}
</style>